import { ApolloClient, InMemoryCache } from '@apollo/client';
import { Button, Card, RichTextContent, focusRing } from '@ths/ui';
import { useNavigate, useParams } from 'react-router-dom';

import { usePublicHotelPortalTermsQuery } from '../generated/graphql';

const publicTermsClient = new ApolloClient({
  uri: import.meta.env.VITE_APP_GRAPHQL_API_URL,
  cache: new InMemoryCache(),
});

export default function TermsOfService() {
  const { versionId } = useParams();
  const navigate = useNavigate();
  const { data, loading, error, refetch } = usePublicHotelPortalTermsQuery({
    client: publicTermsClient,
    variables: { versionId },
    fetchPolicy: 'network-only',
  });
  const terms = data?.publicHotelPortalTerms;
  return (
    <main className="min-h-screen bg-fill px-4 py-10 text-text md:px-6">
      <div className="mx-auto max-w-3xl space-y-6">
        <h1 className="text-3xl font-bold text-text">
          {terms?.title ?? 'Terms of service'}
        </h1>
        {loading ? (
          <p role="status">Loading terms…</p>
        ) : error ? (
          <div role="alert">
            Terms could not be loaded.{' '}
            <Button variant="link" onClick={() => void refetch()}>
              Try again
            </Button>
          </div>
        ) : terms ? (
          <>
            <p className="text-caption text-text-secondary">
              Version {terms.versionNumber} · Published{' '}
              {new Date(terms.publishedAt).toLocaleDateString()}
            </p>
            <Card className="p-5 md:p-6">
              <RichTextContent value={terms.content} />
            </Card>
          </>
        ) : (
          <p className="text-body text-text-secondary">
            {versionId
              ? 'This terms version could not be found.'
              : 'Terms have not been published yet.'}
          </p>
        )}
        <div className="flex flex-wrap items-center gap-5">
          <Button type="button" variant="neutral" onClick={() => navigate('/')}>
            Open portal
          </Button>
          <a
            href="https://www.teamhousing.com/contact/"
            className={`text-accent underline ${focusRing}`}
          >
            Contact THS
          </a>
        </div>
      </div>
    </main>
  );
}
